import { render, staticRenderFns } from "./Bout.vue?vue&type=template&id=2aa86234&"
import script from "./Bout.vue?vue&type=script&lang=js&"
export * from "./Bout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports